import { motion } from 'framer-motion'

// import {
//   CarFront,
//   Handshake,
//   MapPinned,
//   MessageCircleMore,
//   Navigation2,
//   ShieldCheck,
// } from 'lucide-react'

const whyChooseFeatures = [
  {
    title: 'Door-to-Door Service',
    description:
      'Enjoy convenient pickup and drop-off from airports and destinations across Austria.',
    icon: '/assets/images/image-56.svg',
  },
  {
    title: 'English Speaking Drivers',
    description:
      'Friendly, experienced, and English-speaking drivers who know the region well.',
  icon: '/assets/images/image-62.svg',
  },
  {
    title: 'Fixed Transparent Pricing',
    description: 'Transparent pricing with no hidden fees or unexpected charges.',
   icon: '/assets/images/image-63.svg',
  },
  {
    title: 'Cross-Border Travel',
    description: 'Reliable cross-border transfers to Germany and other nearby destinations.',
    icon: '/assets/images/image-85.svg',
  },
  {
    title: 'Luxury Vehicles',
    description:
      'Travel in clean, comfortable vehicles suitable for individuals, families and groups.',
   icon: '/assets/images/image-60.svg',
  },
  {
    title: 'Flexible Stops',
    description:
      'Take scenic breaks, photo stops, or customize your journey along the way.',
   icon: '/assets/images/image-61.svg',
  },
] as const

type WhyChooseCardProps = {
  title: string
  description: string
  icon: string
}

function WhyChooseCard({ title, description, icon }: WhyChooseCardProps) {
  return (
    <motion.article 
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
      }}
      className="relative w-full rounded-[12px] bg-[#365E92] px-6 pb-5 pt-[34px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.06)]"
    >
      <div className="absolute left-1/2 top-0 flex h-[66px] w-[66px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[#ECECC1]">
       <img
          src={icon}
          alt={`${title} icon`}
          className="h-[38px] w-[38px] object-contain"
        />
      </div>

      <h3 className="font-host  mt-4 text-[18px] font-semibold leading-[1.15] tracking-[-0.02em] text-white">
        {title}
      </h3>

      <p className="mx-auto mt-2 max-w-[280px] font-host text-[14px] leading-[1.45] tracking-[-0.01em] text-white/95">
        {description}
      </p>
    </motion.article>
  )
}

export default function WhyChoose() {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(90deg,#f8faf7_0%,#f2f7ef_28%,#cde6ef_100%)] px-4 py-10 sm:px-6 lg:px-[96px] lg:py-[32px]">
      <motion.div 
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={{
          visible: {
            transition: {
              staggerChildren: 0.1,
            },
          },
        }}
        className="mx-auto"
      >
        <motion.div 
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
          }}
          className="mx-auto mb-10 max-w-[600px] text-center"
        >
          <h2 className="font-host text-[24px] font-semibold leading-[1.25] tracking-[-0.02em] text-[#3C3838] lg:text-[30px]">
            Why Travelers Choose Salzburg Cab
          </h2>

          <p className="mt-3 max-w-[520px] font-host text-[16px] font-medium leading-[1.45] tracking-[-0.03em] text-[#8A8686] mb-10">
            From airport transfers to private day trips, we make every
            journey safe, comfortable, and hassle-free.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-x-[10px] gap-y-[34px] md:grid-cols-2 xl:grid-cols-3">
          {whyChooseFeatures.map((feature) => (
            <WhyChooseCard key={feature.title} {...feature} />
          ))}
        </div>
      </motion.div>
    </section>
  )
}